import React, { Component } from 'react';
import classNames from 'classnames';

class MouseMovementWrapper extends Component {
  constructor(props) {
    super(props);
    this._handleMouseMovement = this._handleMouseMovement.bind(this);
    this.state = {
      mouseMovement: false,
    };
  }

  componentDidMount() {
    window.addEventListener('mousemove', this._handleMouseMovement);
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener('mousemove', this._handleMouseMovement);
  }

  render() {
    const { wrapperClass } = this.props;
    const { mouseMovement } = this.state;

    return (
      <div
        className={classNames(wrapperClass, {
          'mouse-move': mouseMovement,
        })}
      >
        {this.props.children}
      </div>
    );
  }

  _handleMouseMovement() {
    if (!this.state.mouseMovement) this.setState({ mouseMovement: true });

    if (this.mouseMoveTimeout) window.clearTimeout(this.mouseMoveTimeout);
    this.mouseMoveTimeout = window.setTimeout(() => {
      this.setState({ mouseMovement: false });
    }, 1000);
  }
}

MouseMovementWrapper.propTypes = {
  children: React.PropTypes.node,
  wrapperClass: React.PropTypes.string,
};

export default MouseMovementWrapper;
